import { fromJS, Map, List } from 'immutable';
import { SAVED_SEARCH_LOAD, SUBSCRIBE_SAVED_SEARCH, UNSUBSCRIBE_SAVED_SEARCH } from './actionTypes';
import { START, SUCCESS, ERROR } from '../../consts';

const DEFAULT_STATE = fromJS({
  loading: false,
  loaded: false,
  error: null,
  items: [],
  _meta: {}
});

export default function savedSearch (state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SAVED_SEARCH_LOAD + START:
      return state.merge({
        loading: true,
        error: null
      });

    case SAVED_SEARCH_LOAD + SUCCESS:
      return state.merge(action.payload, {
        loading: false,
        loaded: true
      });

    case SAVED_SEARCH_LOAD + ERROR:
      return state.merge({
        loading: false,
        loaded: false,
        items: new List(),
        error: action.payload,
        _meta: new Map()
      });

    case SUBSCRIBE_SAVED_SEARCH + SUCCESS:
      return state.merge({
        items: state.get('items').update(
          state.get('items').findIndex(item => {
            return item.get('id') === action.filterId;
          }), item => {
          return item.set('isSubscribed', true);
        })
      });

    case UNSUBSCRIBE_SAVED_SEARCH + SUCCESS:
      return state.merge({
        items: state.get('items').update(
          state.get('items').findIndex(item => {
            return item.get('id') === action.filterId;
          }), item => {
          return item.set('isSubscribed', false);
        })
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/SavedSearch/reducer.js